import { DefaultRootState } from "react-redux";
import { get } from "lodash";
import { parseJSONCapiMessage } from "@fdr/utils/parseJSONCapiMessage";
import { DefaultPlaylistSettings } from "./types";

export const getDefaultPlaylistSettings = (
  store: DefaultRootState
): DefaultPlaylistSettings =>
  parseJSONCapiMessage(store, "capi.messages.homePlaylistSettings", {});

export const getFullscreenModalState = (store: DefaultRootState): boolean =>
  get(store, "modal.isFullscreenVideoOpen", false);
